module.exports = __webpack_public_path__ + "static/img/a082.c60362a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a082.jpg
// module id = 28Mk
// module chunks = 0